import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { CommitAccountSelectionResponse } from "../../../public/supplier-types";
import { commitAccountSelection } from "./supplier-registration.api";

export type CommitAccountSelectionPayload = {
  accountId: string;
};

export const useCommitAccountSelection = (
  connectionRequestId: string
): UseMutationResult<CommitAccountSelectionResponse, unknown, CommitAccountSelectionPayload> =>
  useMutation({
    meta: { silentError: true },
    mutationFn: ({ accountId }: CommitAccountSelectionPayload) =>
      commitAccountSelection(connectionRequestId, accountId),
  });
